<template>
	<vxe-modal v-model="modal" title="付款排期" width="1200" height="800" @show="show" show-footer :loading="loading">
		<template #default>
			<div>
				<el-calendar ref="payCalendar" v-model="date">
					<template slot="dateCell" slot-scope="{date, data}">
						<div>
							<div>
								<span>{{ data.day.split('-').slice(1).join('-') }}</span>
							</div>
							<div style="margin-top: 10px;" v-if="findorderBydate(data.day)">
								<el-tag effect="dark" style="margin: 2px 0;"
									size="mini">订单：{{findorderBydate(data.day).count}}</el-tag>
								<el-tag effect="dark" type="danger" style="margin: 2px 0;"
									size="mini">金额：{{findorderBydate(data.day).amount.toFixed(2)}}</el-tag>
							</div>
						</div>
					</template>
				</el-calendar>
				<div class="flex" style="box-sizing: border-box;padding: 0px 20px;justify-content: flex-end;">
					<el-button size="mini" type="danger"
						style="margin-right: 20px;">未审批笔数：{{unaudittotal.toFixed(2)}}</el-button>
					<el-button size="mini" type="danger"
						style="margin-right: 20px;" @click="flowunauditdataShow">未审批金额：{{unauditamount.toFixed(2)}}</el-button>

					<el-button size="mini" type="primary"
						style="margin-right: 20px;">总计：{{total.toFixed(2)}}</el-button>
					<el-button size="mini" type="primary"
						style="margin-right: 20px;" @click="unpaydataPreviewShow">未付款：{{unpay.toFixed(2)}}</el-button>
					<el-button size="mini" type="primary" style="margin-right: 20px;"
						@click="auditdataShow">待审核：{{audit.toFixed(2)}}</el-button>
					<el-button size="mini" type="primary" @click="paydataShow">已付款：{{pay.toFixed(2)}}</el-button>
				</div>
			</div>
		</template>
		<template #footer>
			<vxe-button status="" content="返回" @click="cancel"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			row: {
				default: () => {
					return null
				}
			},
			time: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				loading: false,
				modal: false,
				date: null,
				tabledata: [],
				flowauditsourcedata: [],
				flowunauditsourcedata: [],
				total: 0,
				pay: 0,
				unpay: 0,
				audit: 0,
				unaudittotal:0,
				unauditamount:0,
				auditdata: [],
				unpaypreviewdata:[],
				paydata: [],
				currenttime: 1
			}
		},
		watch: {
			date(v) {
				let timestamp = new Date(v).getTime()
				let res = this.findorderBydate(window.systemMethods.timestampToDate(timestamp, true))
				if (res) {
					this.unpaydataShow(res)

				}
			},
			currenttime() {
				if (!this.loading) {
					this.init()
				}

			}
		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			unpaydataShow(res) {
				this.$emit('showdetail', {
					data: res,
					type: 'unpay'
				})
			},
			unpaydataPreviewShow() {
				this.$emit('showdetail', {
					detailTitle:'未付款详情',
					data: {					
						data: this.unpaypreviewdata,
						date: ''
					},
					type: 'unpaypreview'
				})
			},
			flowunauditdataShow() {
				this.$emit('showdetail', {
					detailTitle:'未审批详情',
					data: {						
						data: this.flowunaudit,
						date: ''
					},
					type: 'audit'
				})
			},
			auditdataShow() {
				this.$emit('showdetail', {
					detailTitle:'待审核详情',
					data: {						
						data: this.auditdata,
						date: ''
					},
					type: 'audit'
				})
			},
			paydataShow() {
				this.$emit('showdetail', {
					detailTitle:'已付款详情',
					data: {						
						data: this.paydata,
						date: ''
					},
					type: 'pay'
				})
			},
			init() {
				this.loading = true
				this.$api.reconciliation_pay.scheduling({
					currenttime: parseInt(this.currenttime / 1000)
				}).then((res) => {
					let flowaudit = res.flowaudit
					let flowunaudit = res.flowunaudit
					this.flowunauditsourcedata = JSON.parse(JSON.stringify(flowunaudit))
					this.flowauditsourcedata = JSON.parse(JSON.stringify(flowaudit))
					let unpaydata = flowaudit.filter((item) => {
						return !item.ddcode
					})
					this.unpaypreviewdata = unpaydata
					let auditdata = unpaydata.filter((item) => {
						return item.submitstaffid
					})
	
					this.auditdata = auditdata
					let tabledata = unpaydata.filter((item) => {
						return !item.submitstaffid
					})

					let paydata = flowaudit.filter((item) => {
						return item.ddcode
					})
					this.paydata = paydata
					this.tabledata = this.$Lodash.groupBy(tabledata, 'prepaymentdate')

					this.flowunaudit = flowunaudit
					this.unaudittotal = this.flowunauditsourcedata.length
					this.unauditamount = this.$Lodash.sumBy(this.flowunauditsourcedata, item => parseFloat(item.purchasesum))

					this.total = this.$Lodash.sumBy(this.flowauditsourcedata, item => parseFloat(item.needamount))
					this.pay = this.$Lodash.sumBy(paydata, item => parseFloat(item.needamount))
					this.unpay = this.$Lodash.sumBy(unpaydata, item => parseFloat(item.needamount))
					this.audit = this.$Lodash.sumBy(auditdata, item => parseFloat(item.needamount))

					this.loading = false
				})
			},
			cancel() {
				this.modal = false
			},
			hide() {
				this.$emit('hide')
			},
			show() {
				this.currenttime = this.$refs.payCalendar.date.getTime()
				this.init()
			},
			modalShow() {
				this.modal = true
			},
			findorderBydate(date) {
				if (this.$refs.payCalendar) {
					this.currenttime = this.$refs.payCalendar.date.getTime()
				}
				if (this.tabledata[date]) {
					return {
						date: date,
						data: this.tabledata[date],
						amount: this.$Lodash.sumBy(this.tabledata[date], item =>
							parseFloat(item.needamount)),
						count: this.tabledata[date].length
					}
				}
				return null
			}

		},
		components: {

		}
	}
</script>